import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Checkbox } from '../ui/checkbox';
import { ChevronRight } from 'lucide-react';

export default function InformesMensualesForm({ initialData, onSubmit }) {
  const [formData, setFormData] = useState({
    periodo: initialData?.periodo || new Date().toISOString().slice(0, 7),
    incluir_balance: initialData?.incluir_balance ?? true,
    incluir_libro_diario: initialData?.incluir_libro_diario ?? true,
    observaciones: initialData?.observaciones || '',
  });
  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: null }));
  };

  const validate = () => {
    const next = {};
    if (!formData.periodo) next.periodo = 'El periodo es obligatorio';
    if (!formData.incluir_balance && !formData.incluir_libro_diario) {
      next.tipo = 'Debes seleccionar al menos un informe';
    }
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <Label>Periodo *</Label>
        <Input
          type="month"
          value={formData.periodo}
          onChange={(e) => handleChange('periodo', e.target.value)}
          className={errors.periodo ? 'border-red-500' : ''}
          data-testid="input-periodo-informes"
        />
        {errors.periodo && <p className="text-red-500 text-xs mt-1">{errors.periodo}</p>}
      </div>

      <div className="space-y-2">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="incluir_balance"
            checked={formData.incluir_balance}
            onCheckedChange={(checked) => handleChange('incluir_balance', Boolean(checked))}
          />
          <Label htmlFor="incluir_balance" className="cursor-pointer">Incluir balance mensual</Label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox
            id="incluir_libro_diario"
            checked={formData.incluir_libro_diario}
            onCheckedChange={(checked) => handleChange('incluir_libro_diario', Boolean(checked))}
          />
          <Label htmlFor="incluir_libro_diario" className="cursor-pointer">Incluir libro diario</Label>
        </div>
        {errors.tipo && <p className="text-red-500 text-xs mt-1">{errors.tipo}</p>}
      </div>

      <div>
        <Label>Observaciones</Label>
        <Textarea
          value={formData.observaciones}
          onChange={(e) => handleChange('observaciones', e.target.value)}
          rows={3}
          placeholder="Notas sobre el analisis o alcance del informe"
        />
      </div>

      <Button type="submit" className="w-full" data-testid="btn-submit-form">
        Continuar <ChevronRight className="w-4 h-4 ml-2" />
      </Button>
    </form>
  );
}
